<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("loadGlobalConfig");
  },
};
</script>

<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  color: #333;
  font-size: 14px;
  line-height: 1.42;
}

img {
  max-width: 100%;
  display: block;
}

* {
  box-sizing: border-box;
}
</style>
